import { Component, OnInit, ViewChild } from '@angular/core';
import { ArrService, BatchArry, PostIt } from './batchfile';

import { HttpClient } from '@angular/common/http';
import { SharedService } from '../../../../shared/shared.service';
import { MatDialog } from '@angular/material';
import { UsefulToolsService } from 'src/app/shared/other/usefultools.service';

@Component({
  selector: 'app-capture-batch-trips',
  templateUrl: './capture-batch-trips.component.html',
  styleUrls: ['./capture-batch-trips.component.scss'],
  providers: [ArrService]
})

export class CaptureBatchTripsComponent implements OnInit {

  dataSource;
  postThis: PostIt;
  totalBookings: number;
  bookings: number;
  errorMessage;
  showError;
  disableSendToDatabase = true;
  error = 0;
  counter = 0;

  numberPattern: any = '^[0-9]*$';
  timePattern: any = '^([0-1]?[0-9]|[2][0-3]):([0-5][0-9])(:[0-5][0-9])?$';

  formatDateString = this.sharedservice.dateFormatString;

  constructor(
    private httpclient: HttpClient,
    public sharedservice: SharedService,
    private usefultoolsservice: UsefulToolsService
  ) { }

  ngOnInit() {
    // this.dataSource = this.arrService.getBatcharr();
    this.dataSource = [];
    this.totalBookings = this.dataSource.length;
  }

  enableButton() {
    this.disableSendToDatabase = false;
  }

  // dropoffdateset() {
  //   console.log("1");
  //   const x = new Date(this.dataSource.pickUpDate);
  //   x.setHours(x.getHours() + 1);
  //   this.dataSource.dropOffDate = x.toString();
  // }

//   setCellValue (newData, value, currentRowData) {
//     console.log("1");
//     console.log(newData);
//     console.log(currentRowData);
//     const x = new Date(value);
//     x.setHours(x.getHours() + 1);
//     this.dataSource.dropOffDate = x.toString();
// }

  save() {
    this.error = 0;

    this.dataSource.forEach(x => {
      if (this.error === 1) return;

      x.customer = x.customer.replace(new RegExp(';', 'g'), String.fromCharCode(13) + String.fromCharCode(10));

      // if (x.pickUpDate > x.dropOffDate) {
      //   this.counter += 1;
      //   this.usefultoolsservice.notify('error', 'Passenger: ' + x.customer + ', pickup date must be before the drop off date (Row Number: ' + this.counter + ')');
      //   this.error = 1;
      //   return;
      // }

      if (x.numberOfPeople === '0') {
        this.usefultoolsservice.notify('error', 'Passenger: ' + x.customer + ', number of people cannot be zero');
        this.error = 1;
        return;
      }

      if ((x.customer || x.numberOfPeople || x.pickUpAddress || x.pickUpDate
        || x.pickUpTime || x.dropOffAddress || x.dropOffDate || x.dropOffTime) === '') {
        this.usefultoolsservice.notify('error', 'Passenger: ' + x.customer + ', missing required fields');
        this.error = 1;
        return;
      }

      let y = new Date(x.pickUpDate);
      y.setHours(y.getHours() + 1);
      x.dropOffDate = y.toString();
    });

    

    if (this.error === 1) return;

    const postThis = {
      SessionID: sessionStorage.getItem('com-session-id'),
      Trip: JSON.parse(JSON.stringify(this.dataSource)) // to make a copy, not a reference, so that we can change the dates
    };

    // Split date and time before sending back to webservice
    postThis.Trip.forEach((element, index) => {
      const tempPickUpDate = this.usefultoolsservice.convertDate(element.pickUpDate, false);
      const tempDropOffDate = this.usefultoolsservice.convertDate(element.dropOffDate, false);
      postThis.Trip[index]['pickUpDate'] = tempPickUpDate.substr(0, 10);
      postThis.Trip[index]['pickUpTime'] = tempPickUpDate.substr(10, 16);
      postThis.Trip[index]['dropOffDate'] = tempDropOffDate.substr(0, 10);
      postThis.Trip[index]['dropOffTime'] = tempDropOffDate.substr(10, 16);
    });

    this.httpclient.post<any>(`${this.sharedservice.URL}/dbTrip`, postThis).subscribe(Response => {
      // check for error
      if (Response.dbTrip_response.ServiceResults[0].hasOwnProperty('ERRORNUMBER')) {
        this.usefultoolsservice.notify('error', this.sharedservice.notificationMessages.failedInsert)
        return;
      } else {
        this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.successInsert);
        this.disableSendToDatabase = true;
        this.dataSource = [];
      }
    });

  }

  // log(pEvent) {
  //   if (pEvent.target.className === 'dx-icon dx-icon-edit-button-save'
  //     || pEvent.target.children[0].className === 'dx-icon dx-icon-edit-button-save') {
  //     this.totalBookings = this.dataSource.length + 1;
  //   }
  // }
}
